export default "__VITE_ASSET__B4WOzbI5__"